module.exports = __webpack_public_path__ + "h5/img/banner.50739de6.png";